import * as types from './mutation-types'

export default {
    [types.SET_SHARED_PROFILE_USERS](state, sharingProfileUsers) {
        state.sharingProfileUsers = sharingProfileUsers
    },
    [types.SET_UNSHARED_PROFILE_USERS](state, unSharingProfileUsers) {
        state.unSharingProfileUsers = unSharingProfileUsers
    },
    [types.SET_SELECTED_USERS](state, data) {
        state.selectedUsers = data
    },
    [types.RESET_SELECTED_USER](state, data) {
        state.selectedUser = null
    },
    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
}
